import { useFormState } from "react-final-form";
import RffFieldComponentRenderer from "./RffFieldComponentRenderer";

import rffEvaluateFieldCondition from "../../../utils/finalForm/rffEvaluateFieldCondition";

const RffFieldsRenderer = ({ fields }) => {
  const { values } = useFormState();

  return fields?.map((f) => {
    if (!rffEvaluateFieldCondition(f.condition, values)) return null;
    return <RffFieldComponentRenderer key={f.name} field={f} />;
  });
};

export default RffFieldsRenderer;
